module.exports = __webpack_public_path__ + "static/media/deactive_synthesized_audio.1fb5e9b8.svg";